/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react';
import { StyledQuickFilterComponentDiv } from './index.styles';
// import { ComponentProps } from './../../index.types';
import { renderedData } from '../../organisms/searchResults';
import { SearchFilterContext } from '../../index.context';
import { SearchFacetsList, SearchFacetsConstants, SearchFacetsListCodes } from '../../index.constant';
import {
  SearchFacetsResponse,
  // SearchFacetsResponseBuckets,
  SearchStateFilterObj,
} from '../../../store/store.type';
import { SearchActions, getSearchAppliedFilter } from '../../../store/store.action';
import { Button } from '@marriott/mi-ui-library';
import { useSessionUpdateContext } from '../../../../../../context/SessionUpdateContext';
import { formatNumberByLocale } from '../../../../../../utils';
import { usePageContext } from '../../../../../../context/PageContext/index';
import { updateQueryParams } from '../../../lib/helper';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const QuickFiltersComponent: React.FC<{
  filterData?: Array<SearchFacetsResponse>;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ filterData, setFetchCurrencyConversionFactors }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, setFeatureSelected }: any = useContext(renderedData);
  const quickFilters = jsonContent?.quickFilterListArray;
  const clickTrackingLoc = 'Phoenix Search Results';
  const { currentLocale, headersData } = usePageContext();
  const { searchQueryState, setSearchQuery } = useContext(SearchFilterContext);
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  // const getCurrentFilterArray = (): SearchFacetsResponse => {
  //   return searchQueryState?.filter?.filter((key) => key.type.code === SearchFacetsList.amenities)[0];
  // };
  // const [currAvailableAmenities] = useState<SearchFacetsResponse>(getCurrentFilterArray());
  const [currCheckedAmenitiesCode, setCurrCheckedAmenitiesCodeObj] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.amenities] ?? undefined
  );

  const getCurrentFilterArray = (): SearchFacetsResponse => {
    // update amenties
    return filterData
      ? filterData?.filter((key: any) => key.type.code === SearchFacetsListCodes.amenities)[0]
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.amenities)[0];
  };

  const [currAvailableAmenties, setCurrAvailableAmenties] = useState<SearchFacetsResponse | undefined>(
    searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.amenities)[0]
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const quickFilterClick = (amenity: any): void => {
    setFeatureSelected(true);
    setFetchCurrencyConversionFactors(true);
    let obj: SearchStateFilterObj | undefined = { ...currCheckedAmenitiesCode };
    if (obj !== undefined) {
      if (amenity.code in obj) {
        delete obj[amenity.code];
      } else {
        obj[amenity.code] = amenity.code;
      }
    } else {
      obj = {};
      obj[amenity.code] = amenity.code;
    }

    // Update the selected amenities filter values in the URL
    const amenities = Object.values(obj);
    updateQueryParams(
      {
        amenities,
      },
      ['amenities'],
      headersData?.referer
    );

    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: 0,
      },
    });
    setCurrCheckedAmenitiesCodeObj(obj);
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: { [SearchFacetsList.amenities]: obj } });
    setSearchQuery({
      type: SearchActions.setQuery,
      payload: {
        [SearchFacetsConstants.facets]: {
          ...searchQueryState.search[SearchFacetsConstants.facets],
          ...getSearchAppliedFilter({ [SearchFacetsList.amenities]: obj }, searchQueryState),
        },
        [SearchFacetsConstants.options]: {
          ...searchQueryState.search[SearchFacetsConstants.options],
          [SearchFacetsConstants.includeTaxes]: searchQueryState[SearchFacetsConstants.includeTaxes],
          [SearchFacetsConstants.unavailableProperties]: searchQueryState[SearchFacetsConstants.unavailableProperties],
        },
      },
    });
    setInteractionsSelected({ ...interactionsSelected, quickFilters: true });
  };
  const quickFilterAmenities = searchQueryState[SearchFacetsList.amenities];
  useEffect(() => {
    setCurrCheckedAmenitiesCodeObj(searchQueryState.AMENITIES);
  }, [searchQueryState.AMENITIES]);

  useEffect(() => {
    setCurrAvailableAmenties(getCurrentFilterArray());
  }, [searchQueryState.filter]);

  return (
    <StyledQuickFilterComponentDiv>
      <div className="quick-filter-container">
        {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          quickFilters?.map((filter: any, idx: number) => {
            const amenity = { code: filter.amenitiesTagId };
            const isSelected = quickFilterAmenities && amenity?.code ? amenity?.code in quickFilterAmenities : false;
            const isVisibleAmenity = currAvailableAmenties?.buckets.filter(k => k.code === amenity?.code);
            // const count=quickFilterAmenities && amenity?.code==filter.code?amenity?.count:0;
            return isVisibleAmenity && isVisibleAmenity.length ? (
              <Button
                className={`m-button-primary-inverse t-label-alt-m quick-filter-option-button button-secondary custom_click_track ${
                  isSelected ? 'checked' : ''
                }`}
                key={idx}
                callback={() => quickFilterClick && quickFilterClick(amenity)}
                custom_click_track_value={`${clickTrackingLoc}|  ${jsonContent.filterLabel}: ${filter.amenitiesTagTitle} |internal`}
                buttonCopy={`${filter.amenitiesTagTitle}
                (${formatNumberByLocale(isVisibleAmenity[0]?.count, currentLocale)})`}
                isTextBeforeChildren={false}
              >
                {isSelected ? <div className="icon icon-check"></div> : ''}
              </Button>
            ) : null;
          })
        }
      </div>
    </StyledQuickFilterComponentDiv>
  );
};
